import type { PropsWithChildren } from 'react';
import type React from 'react';

import { StarterDashboardV2BannerStateContextProvider } from './context';
import { useBannerState } from './hook';

export const StarterDashboardV2BannerStateProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const bannerState = useBannerState();

	return (
		<StarterDashboardV2BannerStateContextProvider {...bannerState}>
			{children}
		</StarterDashboardV2BannerStateContextProvider>
	);
};
